import React from 'react'

const Orders = () => {
  return (
    <div>Orders Page</div>
  )
}

export default Orders;